import { render } from "./Offices.vue?vue&type=template&id=786123fc&scoped=true"
import script from "./Offices.vue?vue&type=script&lang=js"
export * from "./Offices.vue?vue&type=script&lang=js"

import "./Offices.vue?vue&type=style&index=0&id=786123fc&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786123fc"]])

export default __exports__